import { render, staticRenderFns } from "./QRCodeInstantApp.vue?vue&type=template&id=a5b0d806&scoped=true&"
import script from "./QRCodeInstantApp.vue?vue&type=script&lang=js&"
export * from "./QRCodeInstantApp.vue?vue&type=script&lang=js&"
import style0 from "./QRCodeInstantApp.vue?vue&type=style&index=0&id=a5b0d806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b0d806",
  null
  
)

export default component.exports